export default function SVGHeart({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <path
        d="M721,10703.56c-4.17-.61-46.29-21.62-44.06-48,4-24.53,21.52-22.84,27.15-21.07s15.78,9.45,15.78,9.45,12-11.83,21.38-10.22,34.75,9.62,13.23,43.56c-9,11.89-21.53,20.3-33.22,26.13"
        fill="#ff0083"
      />
      <path
        d="M722.3,10702.5c32.89-13.92,51.13-66.87,8.45-66.75,2.06.1,8.78-3.2,17.17-.38a18.48,18.48,0,0,1,8.64,4.09c2.15,1.78,4.4,4.08,5.24,6.75,4.9,15.61-5,31.83-16.63,41.53l-.88.71c-3.13,2.51-6.47,5-9.75,7.3C727.18,10701,722.3,10702.5,722.3,10702.5Z"
        fill="#dc0071"
      />
      <path
        d="M720.19,10644.25c-9.44-6.11-31.28-15.9-38.82,4.16-7.71,21.58,14.49,39,28.23,49.6-6-2.54-34.8-21.26-32.65-41.42.4-5.21,2.62-12.19,6.51-16.88,15-16.24,37.06,4.43,37.06,4.43"
        fill="#f91090"
      />
      <path
        d="M688.27,10650.59l.09-.23"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M693.13,10672.54c-3.34-3.78-6.35-9-6.1-15.56"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      />
      <path
        d="M723.73,10704.53c-30.13-10.27-50.14-33.21-46.31-53.05,9.15-33.16,47.1-13.54,46.73,3.06-.17,8.36-6.73,7.9-6.71,0,0-29.62,55.85-28.24,43.91,10.17-5,16.65-21.44,30.83-45,41"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
}

export function MobileSVGHeart({ opacity }) {
  return (
    <g style={{ willChange: 'opacity' }} opacity={opacity}>
      <g id="Heart-2-2" data-name="Heart-2">
        <path
          d="M386.2,7749.3c-3.6-.5-40-18.7-38-41.4,3.5-21.2,18.6-19.7,23.4-18.2s13.6,8.1,13.6,8.1,10.4-10.2,18.5-8.8,30,8.3,11.4,37.6c-7.8,10.3-18.6,17.5-28.7,22.6"
          fill="#ff0083"
        />
        <path
          d="M387.3,7748.4c28.4-12,44.2-57.8,7.3-57.6,1.8.1,7.6-2.8,14.8-.3a16.22,16.22,0,0,1,7.5,3.5,12.74,12.74,0,0,1,4.5,5.8c4.2,13.5-4.3,27.5-14.4,35.9l-.8.6c-2.7,2.2-5.6,4.3-8.4,6.3A43.94,43.94,0,0,1,387.3,7748.4Z"
          fill="#dc0071"
        />
        <path
          d="M385.5,7698.1c-8.1-5.3-27-13.7-33.5,3.6-6.7,18.6,12.5,33.6,24.4,42.9-5.2-2.2-30-18.4-28.2-35.8a28.54,28.54,0,0,1,5.6-14.6c12.9-14,32,3.8,32,3.8"
          fill="#f91090"
        />
        <path
          d="M358,7703.5c0-.1,0-.1.1-.2"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M362.2,7722.5a19.51,19.51,0,0,1-5.3-13.4"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        />
        <path
          d="M388.6,7750.1c-26-8.9-43.3-28.7-40-45.8,7.9-28.6,40.7-11.7,40.4,2.6,0,6.6-5.8,6.8-5.8,0,0-25.6,48.2-24.4,37.9,8.8-4.3,14.4-18.5,26.6-38.8,35.4"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  );
}
